import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { useGetGrowthWheelEditorSummariesQuery } from '../../redux/growth-wheel.endpoints'
import '../../css/growthWheel.scss'

const GrowthWheelEditorDetail = () => {
  const { growthWheelId } = useParams<{ growthWheelId: string }>()
  const { data: wheels } = useGetGrowthWheelEditorSummariesQuery()
  const wheel = wheels?.find(w => w.id === Number(growthWheelId))

  return (
    <main className="container-fluid mb-5">
      <div className="gw-editor-landing">
        <Link
          to="/edit-growth-wheel"
          className="gw-competency-back-button mb-4"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          Back to Growth Wheels
        </Link>
        <div className="gw-editor-landing-empty" style={{ border: 'none' }}>
          <h2 className="gw-editor-landing-empty-title">Work in progress</h2>
          <p className="gw-editor-landing-empty-text">
            The editor for {wheel?.roleName} is currently being built.
          </p>
        </div>
      </div>
    </main>
  )
}

export default GrowthWheelEditorDetail
